/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import * as THREE from 'three';
import React, { useMemo } from 'react'
import { const_var, params } from '../../../../../../../redux/reducers/reducer';
import { delModel, extrudeSettings } from '../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../assets/libs/csg-lib';
import { MaterialTruss } from '../../../../../CustomMaterial';

const VerticalLeg = ({ normalMap, envMap, meshDelModel_CSG }) => {
    // const roofRailDistanceY = useMemo(() => {
    //     if(params.trussType === "LST"  || params.trussType === "ECT" || params.trussType === "RNT" || params.trussType === "LCT") return 0.7;
    //     else if(params.trussType === "ACDT" || params.trussType === "CTCT" || params.trussType === "QCT" || params.trussType === "CMT") return 1;
    //     else if (params.trussType === "ACT") return 1.05;
    //     else if(params.trussType === "TWCT") return 0;
    //     else return 0.7
    // }, [params.trussType])
    
    const roofRailDistanceY = 0;

    const railWidth = 0.1;
    const railHeight = 0.2;
    
    const legModel = new THREE.Shape();
    legModel.moveTo(-railWidth / 2, -railHeight / 2);
    legModel.lineTo(-railWidth / 2, railHeight / 2);
    legModel.lineTo(railWidth / 2, railHeight / 2);
    legModel.lineTo(railWidth / 2, -railHeight / 2);
    legModel.closePath();
    
    const modelPosYArr = useMemo(() => {
        let count, distance = 0;
        const initDistance = 4;
        
        const tempCount = Math.floor(params.lean_p_h / initDistance);
        if (params.lean_p_h === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else {
            count = tempCount + 1;
            distance = params.lean_p_h / count;
        }
        
        const tempPosInfoArr = Array.from({ length: count + 2 }, (_, index) => distance * index)
        const posInfoArr = tempPosInfoArr.slice(1, -1);
        
        return posInfoArr
    }, [params.p_w, params.lean_p_h])

    const directionInfoArr = useMemo(() => {
        let isShowFront = false;
        let isShowBack = false;
        let isShowLeft = false;
        let isShowRight = false;

        if (params.p_b_c_b_l_f === 'Close') isShowFront = true;
        if (params.p_b_c_b_l_b === 'Close' && params.p_l_w !== 'Close') isShowBack = true;
        if (params.p_b_c_b_l === 'Close') isShowLeft = true;
        if (params.p_b_c_b_l_r === 'Close') isShowRight = true;

        let offset;
        if(const_var.leanLegstype === 'zigzag') offset = 2;
        else if(const_var.leanLegstype === "ladder") offset = 1;
        else offset = 0;

        const FB_RailLength = params.lean_p_w - offset;
        const LR_RailLength = params.lean_p_d - 2 * railHeight;
        const dataArr = [
            {
                name: 'gable_left_lean_front_leg_vertical',
                direction: 'gableLeftLeanFront',
                isShow: isShowFront,
                size: FB_RailLength,
                angle: 0,
                pos_x: 0,
                pos_z: -FB_RailLength / 2,
                end_pos_x: -(params.p_w / 2 + params.lean_p_d - railHeight / 2),
                end_pos_z: 0,
            },
            {
                name: 'gable_left_lean_back_leg_vertical',
                direction: 'gableLeftLeanBack',
                isShow: isShowBack,
                size: FB_RailLength,
                angle: 0,
                pos_x: 0,
                pos_z: -FB_RailLength / 2,
                end_pos_x: -(params.p_w / 2 + 0.2),
                end_pos_z: 0,
            },
            {
                name: 'gable_left_lean_left_leg_vertical',
                direction: 'gableLeftLeanLeft',
                isShow: isShowLeft,
                size: LR_RailLength,
                angle: -Math.PI / 2,
                pos_x: 0,
                pos_z: 0,
                end_pos_x: -(params.p_w / 2 + 0.15),
                end_pos_z: -(params.lean_p_w / 2 + 0.05),
            },
            {
                name: 'gable_left_lean_right_leg_vertical',
                direction: 'gableLeftLeanRight',
                isShow: isShowRight,
                size: LR_RailLength,
                angle: -Math.PI / 2,
                pos_x: 0,
                pos_z: 0,
                end_pos_x: -(params.p_w / 2 + 0.15),
                end_pos_z: params.lean_p_w / 2 + 0.05,
            },
        ]
        
        return dataArr;
    }, [params.p_w, params.lean_p_w, params.lean_p_d, params.p_b_c_b_l_f, params.p_b_c_b_l_b, params.p_b_c_b_l, params.p_b_c_b_l_r, params.p_l_w, const_var.leanLegstype])

    /************** cutting hole using CSG ***************/    
    const CSGRailGroupArr = useMemo(() => {
        let dataArr = [];

        modelPosYArr.map(model_pos_y => {
            directionInfoArr.map(element => {
                if (element.isShow) {
                    let length, pos_z, offset;

                    if(const_var.leanLegstype === 'zigzag') offset = 2;
                    else if(const_var.leanLegstype === "ladder") offset = 1;
                    else offset = 0;

                    if((element.direction === 'gableLeftLeanFront' || element.direction === 'gableLeftLeanBack') && model_pos_y === params.lean_p_h) {
                        length = element.size - roofRailDistanceY * 2 * 12 / params.b_l_t_r_p + offset - 0.3
                        pos_z = -length / 2;
                    } else {
                        length = element.size
                        pos_z = element.pos_z
                    }
                    
                    const railModel = new THREE.Mesh(new THREE.ExtrudeGeometry(legModel, extrudeSettings(length)));
                    let tempRailModel = railModel.clone();
                    tempRailModel.position.set(element.pos_x, model_pos_y, pos_z);
                    tempRailModel.rotateY(element.angle);
                    tempRailModel.updateMatrix();
                    tempRailModel.updateMatrixWorld();
                    
                    const meshDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel(element.direction, 'leg'), extrudeSettings(3)), new THREE.MeshStandardMaterial({ color: 'red' }));
                    
                    let meshDoorDelModel_CSG = meshDelModel_CSG[element.direction];
                    if (element.direction === 'gableLeftLeanLeft' || element.direction === 'gableLeftLeanRight') {
                        const meshDoorDelModel_Temp = meshDoorDelModel.clone();
                        meshDoorDelModel_Temp.position.set(params.p_w / 2 + 0.15, 0.15, -1.5);
                        meshDoorDelModel_Temp.updateMatrixWorld();

                        meshDoorDelModel_CSG = CSG.fromMesh(meshDoorDelModel_Temp);
                    }
                    
                    const meshTempRailModel_CSG = CSG.fromMesh(tempRailModel);
                    let meshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDoorDelModel_CSG);
                    const CSGRailModel = CSG.toMesh(
                        meshTempRailModel_CSG_Hole,
                        new THREE.Matrix4(),
                    )
                    dataArr.push({ name: element.name, direction: element.direction, CSGRailModel });
                }    
            })
        })
        
        return dataArr;
    }, [params.p_w, modelPosYArr, directionInfoArr, meshDelModel_CSG, legModel, params.lean_p_h, params.lean_p_w, params.lean_p_d, params.b_l_t_r_p, const_var.leanLegstype])
    
    /****************************************** **********/    
    
    return ((params.wallOrientation === "vertical") || (params.wallOrientation === "" && params.p_v_w)) && (
        <group name='vertical_legs'>
            {CSGRailGroupArr.map(item =>
                <mesh
                    name={item.name}
                    geometry={item.CSGRailModel.geometry}
                    position={[
                        directionInfoArr.find(child => child.direction === item.direction).end_pos_x,
                        -0.1,
                        directionInfoArr.find(child => child.direction === item.direction).end_pos_z
                    ]}>
                    <MaterialTruss normalMap={normalMap} envMap={envMap} />
                </mesh>
                
            )}
        </group>
    )
}

export default VerticalLeg